export default __webpack_public_path__ + "static/media/Al ain FC.6a59358e.mp4";